import React from "react";
import { Route, Routes, Navigate, Outlet } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import DashboardPage from "../pages/DashboardPage";
import PinManagementPage from "../pages/PinManagementPage";
import PinDetailPage from "../pages/PinDetailPage"; // Pin Detay sayfası
import UserManagementPage from "../pages/UserManagementPage"; // Yeni sayfayı import et
import UserDetailPage from "../pages/UserDetailPage"; // Kullanıcı Detay sayfası
import MapManagementPage from "../pages/MapManagementPage"; // Harita Yönetimi sayfasını import et

import TimeManagementPage from "../pages/TimeManagementPage"; // Zaman Yönetimi sayfasını import et
import NotificationPage from "../pages/NotificationPage"; // Bildirim Yönetimi
import NotificationLogsPage from "../pages/NotificationLogsPage"; // Bildirim Logları
import AdminLogsPage from "../pages/AdminLogsPage";
import AnnouncementsPage from "../pages/AnnouncementsPage"; // Planlı Duyurular
import TemplatesPage from "../pages/TemplatesPage"; // Şablonlar
import BulkPinCreationPage from "../pages/BulkPinCreationPage"; // Toplu Pin Oluşturma sayfasını import et
import CSVBulkPinCreationPage from "../pages/CSVBulkPinCreationPage"; // CSV Toplu Pin Oluşturma sayfasını import et
import AudioLibraryPage from "../pages/AudioLibraryPage";
import CampaignListPage from "../pages/CampaignListPage"; // Campaign Yönetimi sayfasını import et
import CampaignDetailPage from "../pages/CampaignDetailPage"; // Campaign Detay sayfasını import et
import ReportedPinsPage from "../pages/ReportedPinsPage"; // Şikayet Yönetimi sayfasını import et
import ModerationQueuePage from "../pages/ModerationQueuePage"; // AI Denetim sayfasını import et
import ComplaintListPage from "../pages/ComplaintListPage"; // Yeni Şikayet Listesi sayfası
// Yeni Kampanya Oluşturma sayfasını import et
import UnauthorizedPage from "../pages/UnauthorizedPage"; // Yetkisiz erişim sayfasını import et
import { useAuth } from "../contexts/AuthContext";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Layout from "../components/Layout"; // Layout bileşenini import et

// ProtectedRoute bileşeni: Kullanıcı giriş yapmamışsa login sayfasına yönlendirir.
const ProtectedRoute = ({ children }) => {
  const { currentUser, loading: authLoading } = useAuth(); // AuthContext'ten loading durumunu da al

  // Auth durumu hala yükleniyorsa, bir şey gösterme veya yükleme göstergesi göster
  if (authLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Yükleme tamamlandıktan sonra currentUser ve rolünü kontrol et
  if (!currentUser) {
    // Kullanıcı hiç giriş yapmamışsa /login'e yönlendir
    return <Navigate to="/login" replace />;
  }

  if (!currentUser.isAdmin) {
    // Kullanıcı giriş yapmış ama admin değilse /unauthorized'a yönlendir
    return <Navigate to="/unauthorized" replace />;
  }
  return children; // Kullanıcı giriş yapmış ve rolü 'admin' ise istenen bileşeni render et
};

const AppRouter = () => {
  const { currentUser } = useAuth();

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      {/* Protected Routes */}
      <Route
        element={
          <ProtectedRoute>
            <Layout>
              {" "}
              {/* Layout'u burada sarmalıyoruz */}
              <Outlet /> {/* İçerik burada render edilecek */}
            </Layout>
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/map-management" element={<MapManagementPage />} />

        <Route path="/pin-management" element={<PinManagementPage />} />
        <Route path="/pins/:id" element={<PinDetailPage />} />
        <Route path="/user-management" element={<UserManagementPage />} />
        <Route path="/users/:id" element={<UserDetailPage />} />
        <Route path="/reports" element={<ReportedPinsPage />} />
        <Route path="/complaint-list" element={<ComplaintListPage />} />
        <Route path="/moderation-queue" element={<ModerationQueuePage />} />
        <Route path="/notifications" element={<NotificationPage />} />
        <Route path="/notification-logs" element={<NotificationLogsPage />} />
        <Route path="/announcements" element={<AnnouncementsPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/audio-library" element={<AudioLibraryPage />} />
        <Route path="/admin-logs" element={<AdminLogsPage />} />
        <Route path="/time-management" element={<TimeManagementPage />} />

        {/* Campaign Routes */}
        <Route path="/campaigns" element={<CampaignListPage />} />
        <Route path="/campaigns/new" element={<BulkPinCreationPage />} />
        <Route path="/campaigns/:campaignId" element={<CampaignDetailPage />} />
        <Route path="/bulk-pin-creation" element={<BulkPinCreationPage />} />
        <Route
          path="/csv-bulk-pin-creation"
          element={<CSVBulkPinCreationPage />}
        />
      </Route>

      {/* Fallback Route */}
      <Route
        path="*"
        element={<Navigate to={currentUser ? "/" : "/login"} />}
      />
    </Routes>
  );
};

export default AppRouter;
